import { CourierDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { parseErrorMessage } from '../../../../core/api/api.context';
import { ConfirmationModal } from '../../../../ui/components/pure/modal-content/confirmation-modal.component';
import { useMutationDeactivateIncompleteCourier } from '../../couriers.queries';

export interface DeactivateIncompleteCourierModalProps {
  courier: Pick<CourierDto, 'id' | 'mobile'>;
  onSuccess(): void;
  onCancel(): void;
}

export function DeactivateIncompleteCourierModal({
  courier,
  onSuccess,
  onCancel
}: DeactivateIncompleteCourierModalProps) {
  const deactivateMutation = useMutationDeactivateIncompleteCourier(courier.id);

  return (
    <ConfirmationModal
      title="Deactivate incomplete courier?"
      content={[courier.mobile || 'This courier', 'They will be removed from the incomplete couriers list.']}
      isLoading={deactivateMutation.isLoading}
      errorMessage={deactivateMutation.error ? parseErrorMessage(deactivateMutation.error.message) : undefined}
      onConfirm={() => deactivateMutation.mutate(undefined, { onSuccess })}
      onCancel={onCancel}
      noteRequired={false}
      actionButton={{ label: 'Deactivate', color: 'danger' }}
      cancelButton={{ label: 'Cancel', color: 'secondary' }}
    />
  );
}
